/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MyPortalSessionAuthorizedWrap_session$ref = any;
type ReferralsCandidates_session$ref = any;
export type routePropsReferralsCandidates_QueryVariables = {|
  date_range: string
|};
export type routePropsReferralsCandidates_QueryResponse = {|
  +my_portal_session: ?{|
    +id: string,
    +authorized_referrals: boolean,
    +$fragmentRefs: MyPortalSessionAuthorizedWrap_session$ref & ReferralsCandidates_session$ref,
  |}
|};
export type routePropsReferralsCandidates_Query = {|
  variables: routePropsReferralsCandidates_QueryVariables,
  response: routePropsReferralsCandidates_QueryResponse,
|};
*/


/*
query routePropsReferralsCandidates_Query(
  $date_range: String!
) {
  my_portal_session {
    id
    authorized_referrals
    ...MyPortalSessionAuthorizedWrap_session
    ...ReferralsCandidates_session_3Bwnvq
  }
}

fragment About_session on MyPortal__Session {
  id
  portal_person {
    id
    show_gamification_to_employees
    events_settings {
      activated_account {
        points
        limit
      }
      logged_in {
        points
        limit
      }
      made_direct_referral {
        points
        limit
      }
      made_general_referral {
        points
        limit
      }
      made_social_job_referral {
        points
        limit
      }
      made_social_general_referral {
        points
        limit
      }
      clicked_referral_link {
        points
        limit
      }
      clicked_social_link {
        points
        limit
      }
      apply_started {
        points
        limit
      }
      updated_status_applied {
        points
        limit
      }
      updated_status_in_process {
        points
        limit
      }
      updated_status_offered {
        points
        limit
      }
      updated_status_hired {
        points
        limit
      }
      updated_status_not_successful {
        points
        limit
      }
      finished_probation {
        points
        limit
      }
    }
  }
  referrals_candidates_about_about_section_label: i18n_config_t(key: "myportal.config.referrals.candidates.about.about_section_label")
  referrals_candidates_about_about_section_description: i18n_config_t(key: "myportal.config.referrals.candidates.about.about_section_description")
  referrals_candidates_about_activity_section_label: i18n_config_t(key: "myportal.config.referrals.candidates.about.activity_section_label")
  referrals_candidates_about_activity_header_label: i18n_config_t(key: "myportal.config.referrals.candidates.about.activity_header_label")
  referrals_candidates_about_point_header_label: i18n_config_t(key: "myportal.config.referrals.candidates.about.point_header_label")
  referrals_candidates_about_daily_limit_header_label: i18n_config_t(key: "myportal.config.referrals.candidates.about.daily_limit_header_label")
  referrals_candidates_performance_direct_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.direct_referral_event_log")
  referrals_candidates_performance_general_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.general_referral_event_log")
  referrals_candidates_performance_social_job_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.social_job_referral_event_log")
  referrals_candidates_performance_social_general_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.social_general_referral_event_log")
  referrals_candidates_performance_account_login_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.account_login_event_log")
  referrals_candidates_performance_account_activation_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.account_activation_event_log")
  referrals_candidates_performance_social_link_view_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.social_link_view_event_log")
  referrals_candidates_performance_apply_click_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.apply_click_event_log")
  referrals_candidates_performance_direct_link_view_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.direct_link_view_event_log")
  referrals_candidates_performance_status_change_apply_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_apply_event_log")
  referrals_candidates_performance_status_change_in_process_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_in_process_event_log")
  referrals_candidates_performance_status_change_offer_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_offer_event_log")
  referrals_candidates_performance_status_change_hired_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_hired_event_log")
  referrals_candidates_performance_status_change_not_successful_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_not_successful_event_log")
  referrals_candidates_performance_status_change_finished_probation_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_finished_probation_event_log")
}

fragment AuthFormProvider_session on MyPortal__Session {
  id
  auth_sent
  can_resend_auth
  authorization_unauthorized_page_description_label
  authorization_unauthorized_page_heading: i18n_config_t(key: "myportal.config.authorization.unauthorized.page_heading")
  authorization_unauthorized_have_not_recieved_an_email: i18n_config_t(key: "myportal.config.authorization.unauthorized.have_not_recieved_an_email")
  authorization_unauthorized_actions_send_again: i18n_config_t(key: "myportal.config.authorization.unauthorized.actions.send_again")
}

fragment Leaderboards_session_3Bwnvq on MyPortal__Session {
  portal_person {
    leaderboards(date_range: $date_range) {
      name
      description
      scorers {
        name
        points
        position
      }
    }
    id
  }
  referrals_candidates_leaderboard_leaderboard_section_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_section_label")
  referrals_candidates_leaderboard_leaderboard_top_scorers_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_label")
  referrals_candidates_leaderboard_leaderboard_top_scorers_description: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_description")
  referrals_candidates_leaderboard_leaderboard_most_referrals_made_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_label")
  referrals_candidates_leaderboard_leaderboard_most_referrals_made_description: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_description")
  referrals_candidates_leaderboard_leaderboard_source_of_most_hires_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_label")
  referrals_candidates_leaderboard_leaderboard_source_of_most_hires_description: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_description")
  referrals_candidates_leaderboard_leaderboard_biggest_sharers_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_label")
  referrals_candidates_leaderboard_leaderboard_biggest_sharers_description: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_description")
  referrals_candidates_leaderboard_leaderboard_referred_most_jobs_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_label")
  referrals_candidates_leaderboard_leaderboard_referred_most_jobs_description: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_description")
  referrals_candidates_leaderboard_leaderboard_leading_departments_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_label")
  referrals_candidates_leaderboard_leaderboard_leading_departments_description: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_description")
}

fragment MyPortalSessionAuthorizedWrap_session on MyPortal__Session {
  has_user_authorized
  ...AuthFormProvider_session
}

fragment MyReferrals_session on MyPortal__Session {
  id
  portal_person {
    id
    referrals {
      id
      full_name
      status
      email
      referral_date
      job_external_group_id
      job_title
      formatted_incentive_amount
      formatted_incentive_description
      eligible
      referral_eligibility_reasons {
        id
        description
      }
      is_direct_referral
      is_job_referral
    }
  }
  global_errors_no_records_found: i18n(key: "global.errors.no_records_found")
  referrals_candidates_referral_record_labels_status: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.status")
  referrals_candidates_referral_record_labels_email: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.email")
  referrals_candidates_referral_record_labels_job_title: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.job_title")
  referrals_candidates_referral_record_labels_job_id: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.job_id")
  referrals_candidates_referral_record_labels_referral_date: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.referral_date")
  referrals_candidates_referral_record_labels_reward: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.reward")
  referrals_candidates_referral_record_labels_eligibility: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.eligibility")
  referrals_candidates_referral_record_labels_referral_type: i18n_config_t(key: "myportal.config.referrals.candidates.referral_record_labels.referral_type")
  referrals_candidates_eligibility_eligible: i18n_config_t(key: "myportal.config.referrals.candidates.eligibility.eligible")
  referrals_candidates_eligibility_ineligible: i18n_config_t(key: "myportal.config.referrals.candidates.eligibility.ineligible")
  referrals_candidates_referral_type_direct: i18n_config_t(key: "myportal.config.referrals.candidates.referral_type.direct")
  referrals_candidates_referral_type_general: i18n_config_t(key: "myportal.config.referrals.candidates.referral_type.general")
  referrals_candidates_referral_type_job: i18n_config_t(key: "myportal.config.referrals.candidates.referral_type.job")
  referrals_candidates_referral_type_social: i18n_config_t(key: "myportal.config.referrals.candidates.referral_type.social")
}

fragment Performance_session on MyPortal__Session {
  portal_person {
    id
    gamifications {
      activated_account_count: event_data(type: "activated_account", field: "count")
      logged_in_count: event_data(type: "logged_in", field: "count")
      made_direct_referral_count: event_data(type: "made_direct_referral", field: "count")
      made_general_referral_count: event_data(type: "made_general_referral", field: "count")
      made_social_job_referral_count: event_data(type: "made_social_job_referral", field: "count")
      made_social_general_referral_count: event_data(type: "made_social_general_referral", field: "count")
      clicked_referral_link_count: event_data(type: "clicked_referral_link", field: "count")
      clicked_social_link_count: event_data(type: "clicked_social_link", field: "count")
      apply_started_count: event_data(type: "apply_started", field: "count")
      updated_status_applied_count: event_data(type: "updated_status_applied", field: "count")
      updated_status_in_process_count: event_data(type: "updated_status_in_process", field: "count")
      updated_status_offered_count: event_data(type: "updated_status_offered", field: "count")
      updated_status_hired_count: event_data(type: "updated_status_hired", field: "count")
      updated_status_not_successful_count: event_data(type: "updated_status_not_successful", field: "count")
      finished_probation_count: event_data(type: "finished_probation", field: "count")
      activities {
        id
        date
        activity
        points
      }
      referral_points
    }
  }
  referrals_candidates_gamification_link_view_metric_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.link_view_metric_label")
  referrals_candidates_gamification_hired_metric_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.hired_metric_label")
  referrals_candidates_gamification_performance_apply_click_count: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_apply_click_count")
  referrals_candidates_gamification_performance_social_click_count: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_social_click_count")
  referrals_candidates_gamification_in_process_metric_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.in_process_metric_label")
  referrals_candidates_gamification_applied_metric_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.applied_metric_label")
  referrals_candidates_gamification_offered_metric_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.offered_metric_label")
  referrals_candidates_gamification_performance_referral_job: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_referral_job")
  referrals_candidates_gamification_performance_referral_general: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_referral_general")
  referrals_candidates_gamification_performance_referral_points: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_referral_points")
  referrals_candidates_gamification_my_recent_activity_section_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.my_recent_activity_section_label")
  referrals_candidates_gamification_performance_referral_date: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_referral_date")
  referrals_candidates_gamification_performance_activity: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_activity")
  referrals_candidates_gamification_performance_points: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_points")
  referrals_candidates_performance_direct_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.direct_referral_event_log")
  referrals_candidates_performance_general_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.general_referral_event_log")
  referrals_candidates_performance_social_job_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.social_job_referral_event_log")
  referrals_candidates_performance_social_general_referral_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.social_general_referral_event_log")
  referrals_candidates_performance_account_login_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.account_login_event_log")
  referrals_candidates_performance_account_activation_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.account_activation_event_log")
  referrals_candidates_performance_social_link_view_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.social_link_view_event_log")
  referrals_candidates_performance_apply_click_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.apply_click_event_log")
  referrals_candidates_performance_direct_link_view_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.direct_link_view_event_log")
  referrals_candidates_performance_status_change_apply_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_apply_event_log")
  referrals_candidates_performance_status_change_in_process_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_in_process_event_log")
  referrals_candidates_performance_status_change_offer_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_offer_event_log")
  referrals_candidates_performance_status_change_hired_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_hired_event_log")
  referrals_candidates_performance_status_change_not_successful_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_not_successful_event_log")
  referrals_candidates_performance_status_change_finished_probation_event_log: i18n_config_t(key: "myportal.config.referrals.candidates.performance.status_change_finished_probation_event_log")
}

fragment ReferralsCandidates_session_3Bwnvq on MyPortal__Session {
  id
  ...About_session
  ...Leaderboards_session_3Bwnvq
  ...Performance_session
  ...MyReferrals_session
  portal_person {
    id
    show_gamification_to_employees
    show_about_tab_to_employees
    show_leaderboard_tab_to_employees
    gamification_enabled
    gamifications {
      referral_points
    }
  }
  referrals_candidates_my_referrals: i18n_config_t(key: "myportal.config.referrals.candidates.my_referrals")
  referrals_candidates_page_description: i18n_config_t(key: "myportal.config.referrals.candidates.page_description")
  referrals_candidates_gamification_performance_tab_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_tab_label")
  referrals_candidates_about_about_tab_label: i18n_config_t(key: "myportal.config.referrals.candidates.about.about_tab_label")
  referrals_candidates_leaderboard_leaderboard_tab_label: i18n_config_t(key: "myportal.config.referrals.candidates.leaderboard.leaderboard_tab_label")
  referrals_candidates_referral_points_label: i18n_config_t(key: "myportal.config.referrals.candidates.gamification.performance_referral_points")
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date_range"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorized_referrals",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "date_range",
    "variableName": "date_range"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "limit",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "field",
  "value": "count"
},
v9 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "myportal.config.referrals.candidates.gamification.performance_referral_points"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routePropsReferralsCandidates_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MyPortalSessionAuthorizedWrap_session"
          },
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "ReferralsCandidates_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routePropsReferralsCandidates_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "has_user_authorized",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "auth_sent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "can_resend_auth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorization_unauthorized_page_description_label",
            "storageKey": null
          },
          {
            "alias": "authorization_unauthorized_page_heading",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.page_heading"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.page_heading\")"
          },
          {
            "alias": "authorization_unauthorized_have_not_recieved_an_email",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.have_not_recieved_an_email"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.have_not_recieved_an_email\")"
          },
          {
            "alias": "authorization_unauthorized_actions_send_again",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.actions.send_again"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.actions.send_again\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MyPortal__PortalPerson",
            "kind": "LinkedField",
            "name": "portal_person",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "show_gamification_to_employees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MyPortal__ActivityBreakdown",
                "kind": "LinkedField",
                "name": "events_settings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "activated_account",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "logged_in",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "made_direct_referral",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "made_general_referral",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "made_social_job_referral",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "made_social_general_referral",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "clicked_referral_link",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "clicked_social_link",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "apply_started",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "updated_status_applied",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "updated_status_in_process",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "updated_status_offered",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "updated_status_hired",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "updated_status_not_successful",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__EventSettings",
                    "kind": "LinkedField",
                    "name": "finished_probation",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "MyPortal__Leaderboard",
                "kind": "LinkedField",
                "name": "leaderboards",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__Scorer",
                    "kind": "LinkedField",
                    "name": "scorers",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MyPortal__Gamification",
                "kind": "LinkedField",
                "name": "gamifications",
                "plural": false,
                "selections": [
                  {
                    "alias": "activated_account_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "activated_account"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"activated_account\")"
                  },
                  {
                    "alias": "logged_in_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "logged_in"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"logged_in\")"
                  },
                  {
                    "alias": "made_direct_referral_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "made_direct_referral"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"made_direct_referral\")"
                  },
                  {
                    "alias": "made_general_referral_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "made_general_referral"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"made_general_referral\")"
                  },
                  {
                    "alias": "made_social_job_referral_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "made_social_job_referral"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"made_social_job_referral\")"
                  },
                  {
                    "alias": "made_social_general_referral_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "made_social_general_referral"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"made_social_general_referral\")"
                  },
                  {
                    "alias": "clicked_referral_link_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "clicked_referral_link"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"clicked_referral_link\")"
                  },
                  {
                    "alias": "clicked_social_link_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "clicked_social_link"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"clicked_social_link\")"
                  },
                  {
                    "alias": "apply_started_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "apply_started"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"apply_started\")"
                  },
                  {
                    "alias": "updated_status_applied_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "updated_status_applied"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"updated_status_applied\")"
                  },
                  {
                    "alias": "updated_status_in_process_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "updated_status_in_process"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"updated_status_in_process\")"
                  },
                  {
                    "alias": "updated_status_offered_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "updated_status_offered"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"updated_status_offered\")"
                  },
                  {
                    "alias": "updated_status_hired_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "updated_status_hired"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"updated_status_hired\")"
                  },
                  {
                    "alias": "updated_status_not_successful_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "updated_status_not_successful"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"updated_status_not_successful\")"
                  },
                  {
                    "alias": "finished_probation_count",
                    "args": [
                      (v8/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "finished_probation"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "event_data",
                    "storageKey": "event_data(field:\"count\",type:\"finished_probation\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__Activity",
                    "kind": "LinkedField",
                    "name": "activities",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activity",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referral_points",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MyPortal__Referral",
                "kind": "LinkedField",
                "name": "referrals",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "full_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referral_date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "job_external_group_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "job_title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formatted_incentive_amount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formatted_incentive_description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eligible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__ReferralEligibilityReason",
                    "kind": "LinkedField",
                    "name": "referral_eligibility_reasons",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "is_direct_referral",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "is_job_referral",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "show_about_tab_to_employees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "show_leaderboard_tab_to_employees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gamification_enabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "referrals_candidates_about_about_section_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.about_section_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.about_section_label\")"
          },
          {
            "alias": "referrals_candidates_about_about_section_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.about_section_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.about_section_description\")"
          },
          {
            "alias": "referrals_candidates_about_activity_section_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.activity_section_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.activity_section_label\")"
          },
          {
            "alias": "referrals_candidates_about_activity_header_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.activity_header_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.activity_header_label\")"
          },
          {
            "alias": "referrals_candidates_about_point_header_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.point_header_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.point_header_label\")"
          },
          {
            "alias": "referrals_candidates_about_daily_limit_header_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.daily_limit_header_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.daily_limit_header_label\")"
          },
          {
            "alias": "referrals_candidates_performance_direct_referral_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.direct_referral_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.direct_referral_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_general_referral_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.general_referral_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.general_referral_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_social_job_referral_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.social_job_referral_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.social_job_referral_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_social_general_referral_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.social_general_referral_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.social_general_referral_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_account_login_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.account_login_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.account_login_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_account_activation_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.account_activation_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.account_activation_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_social_link_view_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.social_link_view_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.social_link_view_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_apply_click_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.apply_click_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.apply_click_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_direct_link_view_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.direct_link_view_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.direct_link_view_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_status_change_apply_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.status_change_apply_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.status_change_apply_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_status_change_in_process_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.status_change_in_process_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.status_change_in_process_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_status_change_offer_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.status_change_offer_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.status_change_offer_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_status_change_hired_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.status_change_hired_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.status_change_hired_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_status_change_not_successful_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.status_change_not_successful_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.status_change_not_successful_event_log\")"
          },
          {
            "alias": "referrals_candidates_performance_status_change_finished_probation_event_log",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.performance.status_change_finished_probation_event_log"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.performance.status_change_finished_probation_event_log\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_section_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_section_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_section_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_top_scorers_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_top_scorers_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_description\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_most_referrals_made_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_most_referrals_made_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_description\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_source_of_most_hires_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_source_of_most_hires_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_description\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_biggest_sharers_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_biggest_sharers_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_description\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_referred_most_jobs_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_referred_most_jobs_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_description\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_leading_departments_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_leading_departments_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_description\")"
          },
          {
            "alias": "referrals_candidates_gamification_link_view_metric_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.link_view_metric_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.link_view_metric_label\")"
          },
          {
            "alias": "referrals_candidates_gamification_hired_metric_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.hired_metric_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.hired_metric_label\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_apply_click_count",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_apply_click_count"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_apply_click_count\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_social_click_count",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_social_click_count"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_social_click_count\")"
          },
          {
            "alias": "referrals_candidates_gamification_in_process_metric_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.in_process_metric_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.in_process_metric_label\")"
          },
          {
            "alias": "referrals_candidates_gamification_applied_metric_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.applied_metric_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.applied_metric_label\")"
          },
          {
            "alias": "referrals_candidates_gamification_offered_metric_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.offered_metric_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.offered_metric_label\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_referral_job",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_referral_job"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_referral_job\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_referral_general",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_referral_general"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_referral_general\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_referral_points",
            "args": (v9/*: any*/),
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_referral_points\")"
          },
          {
            "alias": "referrals_candidates_gamification_my_recent_activity_section_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.my_recent_activity_section_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.my_recent_activity_section_label\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_referral_date",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_referral_date"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_referral_date\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_activity",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_activity"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_activity\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_points",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_points"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_points\")"
          },
          {
            "alias": "global_errors_no_records_found",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.errors.no_records_found"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.errors.no_records_found\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_status",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.status"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.status\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_email",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.email"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.email\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_job_title",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.job_title"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.job_title\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_job_id",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.job_id"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.job_id\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_referral_date",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.referral_date"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.referral_date\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_reward",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.reward"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.reward\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_eligibility",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.eligibility"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.eligibility\")"
          },
          {
            "alias": "referrals_candidates_referral_record_labels_referral_type",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_record_labels.referral_type"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_record_labels.referral_type\")"
          },
          {
            "alias": "referrals_candidates_eligibility_eligible",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.eligibility.eligible"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.eligibility.eligible\")"
          },
          {
            "alias": "referrals_candidates_eligibility_ineligible",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.eligibility.ineligible"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.eligibility.ineligible\")"
          },
          {
            "alias": "referrals_candidates_referral_type_direct",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_type.direct"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_type.direct\")"
          },
          {
            "alias": "referrals_candidates_referral_type_general",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_type.general"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_type.general\")"
          },
          {
            "alias": "referrals_candidates_referral_type_job",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_type.job"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_type.job\")"
          },
          {
            "alias": "referrals_candidates_referral_type_social",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.referral_type.social"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.referral_type.social\")"
          },
          {
            "alias": "referrals_candidates_my_referrals",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.my_referrals"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.my_referrals\")"
          },
          {
            "alias": "referrals_candidates_page_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.page_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.page_description\")"
          },
          {
            "alias": "referrals_candidates_gamification_performance_tab_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.gamification.performance_tab_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_tab_label\")"
          },
          {
            "alias": "referrals_candidates_about_about_tab_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.about.about_tab_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.about.about_tab_label\")"
          },
          {
            "alias": "referrals_candidates_leaderboard_leaderboard_tab_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.candidates.leaderboard.leaderboard_tab_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.leaderboard.leaderboard_tab_label\")"
          },
          {
            "alias": "referrals_candidates_referral_points_label",
            "args": (v9/*: any*/),
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.candidates.gamification.performance_referral_points\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dbef715de1493911115419962d19dddc",
    "id": null,
    "metadata": {},
    "name": "routePropsReferralsCandidates_Query",
    "operationKind": "query",
    "text": "query routePropsReferralsCandidates_Query(\n  $date_range: String!\n) {\n  my_portal_session {\n    id\n    authorized_referrals\n    ...MyPortalSessionAuthorizedWrap_session\n    ...ReferralsCandidates_session_3Bwnvq\n  }\n}\n\nfragment About_session on MyPortal__Session {\n  id\n  portal_person {\n    id\n    show_gamification_to_employees\n    events_settings {\n      activated_account {\n        points\n        limit\n      }\n      logged_in {\n        points\n        limit\n      }\n      made_direct_referral {\n        points\n        limit\n      }\n      made_general_referral {\n        points\n        limit\n      }\n      made_social_job_referral {\n        points\n        limit\n      }\n      made_social_general_referral {\n        points\n        limit\n      }\n      clicked_referral_link {\n        points\n        limit\n      }\n      clicked_social_link {\n        points\n        limit\n      }\n      apply_started {\n        points\n        limit\n      }\n      updated_status_applied {\n        points\n        limit\n      }\n      updated_status_in_process {\n        points\n        limit\n      }\n      updated_status_offered {\n        points\n        limit\n      }\n      updated_status_hired {\n        points\n        limit\n      }\n      updated_status_not_successful {\n        points\n        limit\n      }\n      finished_probation {\n        points\n        limit\n      }\n    }\n  }\n  referrals_candidates_about_about_section_label: i18n_config_t(key: \"myportal.config.referrals.candidates.about.about_section_label\")\n  referrals_candidates_about_about_section_description: i18n_config_t(key: \"myportal.config.referrals.candidates.about.about_section_description\")\n  referrals_candidates_about_activity_section_label: i18n_config_t(key: \"myportal.config.referrals.candidates.about.activity_section_label\")\n  referrals_candidates_about_activity_header_label: i18n_config_t(key: \"myportal.config.referrals.candidates.about.activity_header_label\")\n  referrals_candidates_about_point_header_label: i18n_config_t(key: \"myportal.config.referrals.candidates.about.point_header_label\")\n  referrals_candidates_about_daily_limit_header_label: i18n_config_t(key: \"myportal.config.referrals.candidates.about.daily_limit_header_label\")\n  referrals_candidates_performance_direct_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.direct_referral_event_log\")\n  referrals_candidates_performance_general_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.general_referral_event_log\")\n  referrals_candidates_performance_social_job_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.social_job_referral_event_log\")\n  referrals_candidates_performance_social_general_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.social_general_referral_event_log\")\n  referrals_candidates_performance_account_login_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.account_login_event_log\")\n  referrals_candidates_performance_account_activation_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.account_activation_event_log\")\n  referrals_candidates_performance_social_link_view_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.social_link_view_event_log\")\n  referrals_candidates_performance_apply_click_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.apply_click_event_log\")\n  referrals_candidates_performance_direct_link_view_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.direct_link_view_event_log\")\n  referrals_candidates_performance_status_change_apply_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_apply_event_log\")\n  referrals_candidates_performance_status_change_in_process_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_in_process_event_log\")\n  referrals_candidates_performance_status_change_offer_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_offer_event_log\")\n  referrals_candidates_performance_status_change_hired_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_hired_event_log\")\n  referrals_candidates_performance_status_change_not_successful_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_not_successful_event_log\")\n  referrals_candidates_performance_status_change_finished_probation_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_finished_probation_event_log\")\n}\n\nfragment AuthFormProvider_session on MyPortal__Session {\n  id\n  auth_sent\n  can_resend_auth\n  authorization_unauthorized_page_description_label\n  authorization_unauthorized_page_heading: i18n_config_t(key: \"myportal.config.authorization.unauthorized.page_heading\")\n  authorization_unauthorized_have_not_recieved_an_email: i18n_config_t(key: \"myportal.config.authorization.unauthorized.have_not_recieved_an_email\")\n  authorization_unauthorized_actions_send_again: i18n_config_t(key: \"myportal.config.authorization.unauthorized.actions.send_again\")\n}\n\nfragment Leaderboards_session_3Bwnvq on MyPortal__Session {\n  portal_person {\n    leaderboards(date_range: $date_range) {\n      name\n      description\n      scorers {\n        name\n        points\n        position\n      }\n    }\n    id\n  }\n  referrals_candidates_leaderboard_leaderboard_section_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_section_label\")\n  referrals_candidates_leaderboard_leaderboard_top_scorers_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_label\")\n  referrals_candidates_leaderboard_leaderboard_top_scorers_description: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_top_scorers_description\")\n  referrals_candidates_leaderboard_leaderboard_most_referrals_made_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_label\")\n  referrals_candidates_leaderboard_leaderboard_most_referrals_made_description: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_most_referrals_made_description\")\n  referrals_candidates_leaderboard_leaderboard_source_of_most_hires_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_label\")\n  referrals_candidates_leaderboard_leaderboard_source_of_most_hires_description: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_source_of_most_hires_description\")\n  referrals_candidates_leaderboard_leaderboard_biggest_sharers_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_label\")\n  referrals_candidates_leaderboard_leaderboard_biggest_sharers_description: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_biggest_sharers_description\")\n  referrals_candidates_leaderboard_leaderboard_referred_most_jobs_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_label\")\n  referrals_candidates_leaderboard_leaderboard_referred_most_jobs_description: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_referred_most_jobs_description\")\n  referrals_candidates_leaderboard_leaderboard_leading_departments_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_label\")\n  referrals_candidates_leaderboard_leaderboard_leading_departments_description: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_leading_departments_description\")\n}\n\nfragment MyPortalSessionAuthorizedWrap_session on MyPortal__Session {\n  has_user_authorized\n  ...AuthFormProvider_session\n}\n\nfragment MyReferrals_session on MyPortal__Session {\n  id\n  portal_person {\n    id\n    referrals {\n      id\n      full_name\n      status\n      email\n      referral_date\n      job_external_group_id\n      job_title\n      formatted_incentive_amount\n      formatted_incentive_description\n      eligible\n      referral_eligibility_reasons {\n        id\n        description\n      }\n      is_direct_referral\n      is_job_referral\n    }\n  }\n  global_errors_no_records_found: i18n(key: \"global.errors.no_records_found\")\n  referrals_candidates_referral_record_labels_status: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.status\")\n  referrals_candidates_referral_record_labels_email: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.email\")\n  referrals_candidates_referral_record_labels_job_title: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.job_title\")\n  referrals_candidates_referral_record_labels_job_id: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.job_id\")\n  referrals_candidates_referral_record_labels_referral_date: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.referral_date\")\n  referrals_candidates_referral_record_labels_reward: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.reward\")\n  referrals_candidates_referral_record_labels_eligibility: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.eligibility\")\n  referrals_candidates_referral_record_labels_referral_type: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_record_labels.referral_type\")\n  referrals_candidates_eligibility_eligible: i18n_config_t(key: \"myportal.config.referrals.candidates.eligibility.eligible\")\n  referrals_candidates_eligibility_ineligible: i18n_config_t(key: \"myportal.config.referrals.candidates.eligibility.ineligible\")\n  referrals_candidates_referral_type_direct: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_type.direct\")\n  referrals_candidates_referral_type_general: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_type.general\")\n  referrals_candidates_referral_type_job: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_type.job\")\n  referrals_candidates_referral_type_social: i18n_config_t(key: \"myportal.config.referrals.candidates.referral_type.social\")\n}\n\nfragment Performance_session on MyPortal__Session {\n  portal_person {\n    id\n    gamifications {\n      activated_account_count: event_data(type: \"activated_account\", field: \"count\")\n      logged_in_count: event_data(type: \"logged_in\", field: \"count\")\n      made_direct_referral_count: event_data(type: \"made_direct_referral\", field: \"count\")\n      made_general_referral_count: event_data(type: \"made_general_referral\", field: \"count\")\n      made_social_job_referral_count: event_data(type: \"made_social_job_referral\", field: \"count\")\n      made_social_general_referral_count: event_data(type: \"made_social_general_referral\", field: \"count\")\n      clicked_referral_link_count: event_data(type: \"clicked_referral_link\", field: \"count\")\n      clicked_social_link_count: event_data(type: \"clicked_social_link\", field: \"count\")\n      apply_started_count: event_data(type: \"apply_started\", field: \"count\")\n      updated_status_applied_count: event_data(type: \"updated_status_applied\", field: \"count\")\n      updated_status_in_process_count: event_data(type: \"updated_status_in_process\", field: \"count\")\n      updated_status_offered_count: event_data(type: \"updated_status_offered\", field: \"count\")\n      updated_status_hired_count: event_data(type: \"updated_status_hired\", field: \"count\")\n      updated_status_not_successful_count: event_data(type: \"updated_status_not_successful\", field: \"count\")\n      finished_probation_count: event_data(type: \"finished_probation\", field: \"count\")\n      activities {\n        id\n        date\n        activity\n        points\n      }\n      referral_points\n    }\n  }\n  referrals_candidates_gamification_link_view_metric_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.link_view_metric_label\")\n  referrals_candidates_gamification_hired_metric_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.hired_metric_label\")\n  referrals_candidates_gamification_performance_apply_click_count: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_apply_click_count\")\n  referrals_candidates_gamification_performance_social_click_count: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_social_click_count\")\n  referrals_candidates_gamification_in_process_metric_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.in_process_metric_label\")\n  referrals_candidates_gamification_applied_metric_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.applied_metric_label\")\n  referrals_candidates_gamification_offered_metric_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.offered_metric_label\")\n  referrals_candidates_gamification_performance_referral_job: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_referral_job\")\n  referrals_candidates_gamification_performance_referral_general: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_referral_general\")\n  referrals_candidates_gamification_performance_referral_points: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_referral_points\")\n  referrals_candidates_gamification_my_recent_activity_section_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.my_recent_activity_section_label\")\n  referrals_candidates_gamification_performance_referral_date: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_referral_date\")\n  referrals_candidates_gamification_performance_activity: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_activity\")\n  referrals_candidates_gamification_performance_points: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_points\")\n  referrals_candidates_performance_direct_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.direct_referral_event_log\")\n  referrals_candidates_performance_general_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.general_referral_event_log\")\n  referrals_candidates_performance_social_job_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.social_job_referral_event_log\")\n  referrals_candidates_performance_social_general_referral_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.social_general_referral_event_log\")\n  referrals_candidates_performance_account_login_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.account_login_event_log\")\n  referrals_candidates_performance_account_activation_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.account_activation_event_log\")\n  referrals_candidates_performance_social_link_view_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.social_link_view_event_log\")\n  referrals_candidates_performance_apply_click_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.apply_click_event_log\")\n  referrals_candidates_performance_direct_link_view_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.direct_link_view_event_log\")\n  referrals_candidates_performance_status_change_apply_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_apply_event_log\")\n  referrals_candidates_performance_status_change_in_process_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_in_process_event_log\")\n  referrals_candidates_performance_status_change_offer_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_offer_event_log\")\n  referrals_candidates_performance_status_change_hired_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_hired_event_log\")\n  referrals_candidates_performance_status_change_not_successful_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_not_successful_event_log\")\n  referrals_candidates_performance_status_change_finished_probation_event_log: i18n_config_t(key: \"myportal.config.referrals.candidates.performance.status_change_finished_probation_event_log\")\n}\n\nfragment ReferralsCandidates_session_3Bwnvq on MyPortal__Session {\n  id\n  ...About_session\n  ...Leaderboards_session_3Bwnvq\n  ...Performance_session\n  ...MyReferrals_session\n  portal_person {\n    id\n    show_gamification_to_employees\n    show_about_tab_to_employees\n    show_leaderboard_tab_to_employees\n    gamification_enabled\n    gamifications {\n      referral_points\n    }\n  }\n  referrals_candidates_my_referrals: i18n_config_t(key: \"myportal.config.referrals.candidates.my_referrals\")\n  referrals_candidates_page_description: i18n_config_t(key: \"myportal.config.referrals.candidates.page_description\")\n  referrals_candidates_gamification_performance_tab_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_tab_label\")\n  referrals_candidates_about_about_tab_label: i18n_config_t(key: \"myportal.config.referrals.candidates.about.about_tab_label\")\n  referrals_candidates_leaderboard_leaderboard_tab_label: i18n_config_t(key: \"myportal.config.referrals.candidates.leaderboard.leaderboard_tab_label\")\n  referrals_candidates_referral_points_label: i18n_config_t(key: \"myportal.config.referrals.candidates.gamification.performance_referral_points\")\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f2c9baae11b3c78578e84fb2400dadf';

module.exports = node;
